module.exports = __webpack_public_path__ + "media/application/images/ui/menu-table-cde561998998f0abdd7bab03a285139e.svg";